<app-modal
  *ngIf="mainContent && secondaryAction && primaryAction"
  [modalTitle]="'projectDetails.investDialog.title' | translate"
  [mainContentTemplate]="mainContent"
  [secondaryActionTemplate]="secondaryAction"
  [primaryActionTemplate]="primaryAction"
  (closed)="activeModal.dismiss()"
></app-modal>

<ng-template #mainContent>
  <p>{{ projectDetails?.name }}</p>
  <form [formGroup]="investForm">
    <div class="mb-3">
      <app-validated-currency-input
        label="projectDetails.investDialog.amountLabel"
        [feedback]="
          'projectDetails.investDialog.amountFeedback'
            | translate
              : {
                  amount:
                    minAmount
                    | currencyFormat: projectDetails?.currency ?? 'EUR',
                }
        "
        [currencyCode]="projectDetails?.currency ?? 'EUR'"
        [inputFormControl]="investForm.controls.amount"
        inputFormControlName="amount"
        [validationTrainslations]="{
          required: 'projectDetails.investDialog.required' | translate,
          min:
            'projectDetails.investDialog.minAmount'
            | translate
              : {
                  minAmount:
                    minAmount
                    | currencyFormat: projectDetails?.currency ?? 'EUR',
                },
          max:
            'projectDetails.investDialog.maxAmount'
            | translate
              : {
                  maxAmount:
                    maxAmount
                    | currencyFormat: projectDetails?.currency ?? 'EUR',
                },
        }"
      ></app-validated-currency-input>
      <app-validated-checkbox
        label="projectDetails.investDialog.riskConsent"
        inputFormControlName="consent"
        [inputFormControl]="investForm.controls.consent"
      ></app-validated-checkbox>
    </div>
  </form>
</ng-template>

<ng-template #secondaryAction>
  <button
    class="btn btn-falcon-default btn-sm me-3"
    type="button"
    (click)="activeModal.dismiss()"
  >
    {{ "projectDetails.investDialog.cancel" | translate }}
  </button>
</ng-template>

<ng-template #primaryAction>
  <button
    class="btn btn-primary btn-sm"
    type="submit"
    (click)="applyInvestment()"
  >
    <span class="fab fa-telegram-plane"> </span>
    {{ "projectDetails.investDialog.ok" | translate }}
  </button>
</ng-template>
